/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { Button, ButtonGroup } from 'reactstrap';
import axios from 'axios';
import { db } from '../firebase';
import { doc, getDoc, collection, setDoc } from "firebase/firestore"; // Importuj niezbędne funkcje z Firestore
import { onAuthStateChanged } from "firebase/auth"; // Importowanie funkcji
import {
  List,
  ListItem,
  ListItemSuffix,
  Card,
  IconButton,
} from "@material-tailwind/react";
import { MdModeEditOutline } from "react-icons/md";
import { useDispatch } from 'react-redux'
import { updateUser, updateAccountType } from '../features/counter/counterSlice';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux'
import { FaRegEye } from "react-icons/fa6";
import { FaRegEyeSlash } from "react-icons/fa6";
import { Spinner } from 'reactstrap';
import { auth } from "../firebase"

function Accounts() {
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordBool, setPasswordBool] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState();
  const [confirmPasswordBool, setConfirmPasswordBool] = useState(false);
  const [displayName, setDisplayName] = useState();
  const [managers, setManagers] = useState([]);
  const [porters, setPorters] = useState([]);
  const [user, setUser] = useState();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const accountType = useSelector(state => state.store.accountType);
  const [isLoading, setIsLoading] = useState(false);

  const cleanAll = () => {
    setName();
    setSurname();
    setEmail();
    setPassword();
    setConfirmPassword();
  }

  const openToast = (message) => {
    const Toastify__toast = document.querySelector('.Toastify__toast ');
      if(Toastify__toast === null){
      toast.error(message, {
        position: 'top-center',
      });
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) { // Sprawdzenie, czy użytkownik jest zalogowany
        if (user.displayName === 'porter') {
          navigate('/super-admin/parking-map');
        } else if (user.displayName === 'manager') {
          navigate('/super-admin/pre-alerts-managment');
        }
      } else {
        navigate('/sign-in'); // Przekierowanie do strony logowania, jeśli użytkownik nie jest zalogowany
      }
    });

    // Zwrócenie funkcji unsubscribing do czyszczenia
    return () => unsubscribe();
  }, [navigate]); // Dodanie navigate do zależności

  const getUserList = async () => {
    try {
      const response = await axios.get('http://localhost:8080/users');
      
      // Filtruj i dodawaj menedżerów i portierów
      const managersPromises = response.data
        .filter(user => user.displayName === 'manager')
        .map(async (user) => {
          const userDocRef = doc(db, 'users', user.uid);
          const usersNames = await getDoc(userDocRef); // Użyj getDoc z Firebase 9
          const userInfo = {
            ...user,
            ...(usersNames.exists() ? usersNames.data() : {})
          };
          setManagers(prevManagers => [...prevManagers, userInfo]);
        });
  
      const portersPromises = response.data
        .filter(user => user.displayName === 'porter')
        .map(async (user) => {
          const userDocRef = doc(db, 'users', user.uid);
          const usersNames = await getDoc(userDocRef); // Użyj getDoc z Firebase 9
          const userInfo = {
            ...user,
            ...(usersNames.exists() ? usersNames.data() : {})
          };
          setPorters(prevPorters => [...prevPorters, userInfo]);
        });
  
      // Wait for all promises to resolve
      await Promise.all([...managersPromises, ...portersPromises]);
  
    } catch (error) {
      console.error("Error fetching user list:", error); // Obsługa błędu
    }
  };

  useEffect(() => {
    getUserList();
  }, [])

  const registerAccount = async (e) => {
    e.preventDefault();
  
    if (password === confirmPassword) {
      setIsLoading(true);
  
      try {

        // Tworzenie konta za pomocą API
        const res = await axios.post('http://localhost:8080/createAccount',
          {
            email: email,
            password: password,
            displayName: accountType.toLowerCase()
          });
        
        // Sprawdzenie, czy odpowiedź zawiera dane
        if (res.data) {
          // Dodawanie użytkownika do Firestore
          const userRef = doc(collection(db, 'users'), res.data); // Referencja do dokumentu
          await setDoc(userRef, {
            name: name,
            surname: surname,
            password: password,
            role: accountType.toLowerCase()
          });
        
          // Odświeżenie strony po zapisaniu danych
          window.location.reload();
        }
      } catch (err) {
        openToast('This account already exists with the provided email address');
        console.error(err);
      } finally {
        setIsLoading(false); // Zatrzymaj ładowanie niezależnie od wyniku
      }
    } else {
      openToast('The passwords must match');
    }
  };

  useEffect(() => {
    const buttonGroup = document.querySelectorAll('#btn-group')[0];
    if(buttonGroup){
      Array.prototype.slice.call(buttonGroup.children).forEach((button) => {
        if(button.innerHTML === accountType){
          button.classList.add('activeButton');
        }else{
          button.classList.remove('activeButton');
        }
      })
    }
  }, [accountType])

  const editUser = (user) => {
    dispatch(updateUser(user));
    navigate('/super-admin/edit-profile');
  } 

  return (
    <>
     <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <ToastContainer style={{ width: '800px' }} autoClose={2000}/>
      <div className="content" style={{ display: 'flex', flexDirection: 'row' }}>
      <Card className='bg-my-black' style={{ borderRadius: '8px', width: '20%', padding: '5px' }}>
        <ButtonGroup id='btn-group'>
          <Button style={{ width: '81px' }} onClick={() => dispatch(updateAccountType('Manager'))}>Manager</Button>
          <Button onClick={() => dispatch(updateAccountType('Porter'))}>Porter</Button>
        </ButtonGroup>
        {(accountType == 'Manager' ? (managers.length > 0  ? managers.map((user, index) => (
          <ListItem style={{ color: '#fff', height: '45px' }} onClick={() => editUser(user)} className="py-1 pr-1 pl-4 list">
            <div style={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between', alignItems: 'center' }}>
              {user.name} {user.surname}
              <MdModeEditOutline style={{ width:'1.25em', height: '1.25em'}}/>
            </div>
          </ListItem>
        )) : '') : (porters.length > 0  ? porters.map((user, index) => (
          <ListItem style={{ color: '#fff', height: '45px' }} onClick={() => editUser(user)} className="py-1 pr-1 pl-4 list">
            <div style={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'row nowrap', justifyContent: 'space-between', alignItems: 'center' }}>
              {user.name} {user.surname}
              <MdModeEditOutline style={{ width:'1.25em', height: '1.25em'}}/>
            </div>
          </ListItem>
        )) : ''))}
      </Card>
      <div style={{ width: '80%' }} className="flex min-h-full flex-col justify-center px-6 lg:px-8">
      {(isLoading ? <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm"><div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="mb-3">
      <Spinner
        style={{ marginLeft: '1rem' }}
        color="dark"
        size=""
      >
        Loading...
      </Spinner></div></div> : <><div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Register {accountType}</h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={(e) => registerAccount(e)}>
        <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Name
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="name"
              name='name'
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Surname
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="surname"
              name='surname'
              onChange={(e) => setSurname(e.target.value)}
              required
            />
          </div>
        <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Email
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="office@slampoland.pl"
              name='email'
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
    
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput" className="form-label">
              Password
            </label>
            <div style={{ display: 'flex', flexFlow: 'row nowarp', alignItems: 'center', position: 'relative' }}>
              <input
                type={(passwordBool ? 'text' : "password")}
                className="form-control"
                id="formGroupExampleInput"
                placeholder='password'
                name='password'
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span style={{ position: 'absolute', right: '10px' }}>{(passwordBool ? <FaRegEyeSlash style={{ width: '18px' }} onClick={() => setPasswordBool(false)}/> : <FaRegEye onClick={() => setPasswordBool(true)}/>)}</span>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput" className="form-label">
              Confir password
            </label>
            <div style={{ display: 'flex', flexFlow: 'row nowarp', alignItems: 'center', position: 'relative' }}>
              <input
                type={(confirmPasswordBool ? 'text' : "password")}
                className="form-control"
                id="formGroupExampleInput"
                placeholder='confirm password'
                name='confirmPassword'
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span style={{ position: 'absolute', right: '10px' }}>{(confirmPasswordBool ? <FaRegEyeSlash style={{ width: '18px' }} onClick={() => setConfirmPasswordBool(false)}/> : <FaRegEye onClick={() => setConfirmPasswordBool(true)}/>)}</span>
            </div>
          </div>
          <div>
            <button type='submit' className="flex w-full justify-center rounded-md btn btn-warning px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm ">Register</button>
          </div>
        </form>
      </div></>)}
    </div>
    </div>
    </>
  );
}

export default Accounts;
